import { render, staticRenderFns } from "./GamePlan2.vue?vue&type=template&id=8e735012&"
import script from "./GamePlan2.vue?vue&type=script&lang=js&"
export * from "./GamePlan2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports